import {
	StringListProperty,
	StringProperty,
} from "../../../@types/EpiFoundationSpa/Property"
import {
	Flex,
	Text,
} from "@capioweb/ui-components/src"
import React from "react"
import { BlockCommonLayout } from "../../../utils/layout"
import { SearchComponent } from '../../../components/SearchHeroBlock/components/SearchComponent'

interface SearchHeroBlockProps {
	heading: StringProperty
	commonSearches?: CommonSearch[]
	commonSearchesTitle?: StringListProperty
	query?: string
}

interface CommonSearch {
	text: string
	link: string
}

const SiteSearchBlock: React.FC<SearchHeroBlockProps> = ({
	heading,
	query,
}) => {

	return (
		<BlockCommonLayout backgroundColor="white" noPaddingBottom>
			<Flex w={1} flexDirection="column" alignItems="center">
				<Flex>
					<Text as="h1" variant="headline-1" textAlign="center" my={2}>
						{heading.value}
					</Text>
				</Flex>
				<SearchComponent query={query} isStartPage={false} />
			</Flex>
		</BlockCommonLayout>
	)
}

export { SiteSearchBlock }
